import createAction from '@/Framework/State/Redux/createAction';
import actionTypes from './actionTypes';

export const setTenant = (tenant) => createAction(actionTypes.SET_TENANT, { tenant });
